import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=ab9f2aea&scoped=true&"
import script from "./ModalFooter.vue?vue&type=script&lang=ts&"
export * from "./ModalFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=ab9f2aea&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9f2aea",
  null
  
)

export default component.exports